









import { Vue, Component } from 'vue-property-decorator'
import { generateOpenGraphMetaForPage } from '~plugins/utils'
import { entityDecode } from '~~/utils/entity-decode.js'
import Page from '~components/content/pages/Page.vue'
import PromotionPage from '~components/content/pages/PromotionPage.vue'
import { Page as PageType } from '~base/common/types'

@Component<PageTypePage>({
  components: {
    Page,
    PromotionPage,
  },
  head() {
    if (!this.page) {
      return {
        title: '...',
        meta: [],
      }
    }
    // replace all potential html from the title with a whitespace
    // and then remove excessive whitespace
    const title = this.page.title.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ')
    return {
      title: `${entityDecode(title)} - ${this.$config.siteName}`,
      meta: this.meta,
    }
  },

  async asyncData({ error, app, params, redirect, route }) {
    const page = await app.apolloProvider?.defaultClient
      .query({
        query: require('~base/graphql/queries/PageBySlug.gql'),
        variables: { page_slug: params.cat_or_page_slug },
      })
      .then(
        ({ data }) =>
          data.pages && data.pages.nodes.length > 0 && data.pages.nodes[0]
      )
    if (!page) {
      if (process.browser && !navigator.onLine) {
        error({ statusCode: 200, message: 'offline' })
      } else if (app.$config.environment === 'local') {
        console.error(`Page ${route.fullPath} not found`)
        error({ statusCode: 404 })
      } else if (app.$config.redirect404) {
        redirect(`${app.$config.redirect404}${route.fullPath}`)
      } else {
        error({ statusCode: 404 })
      }
      return
    }
    return { page }
  },
})
export default class PageTypePage extends Vue {
  private page: PageType | null = null

  mounted() {
    window.scrollTo(0, 0)
    this.$store.dispatch('tracking/trackOtherPage', this.page)
    this.$store.dispatch('ads/pageChanged', { pageType: 'page' })
  }

  get meta() {
    if (this.page !== null)
      return generateOpenGraphMetaForPage(this.page, this.$config)
    return []
  }

  get isPromotionPage() {
    return this.page?.template?.__typename === 'Template_MarketingLandingPage'
  }
}
